import axiosClient from './axiosClient';

export const getQuoteDetail = (id?: string) => {
    const url = `${process.env.REACT_APP_PUBLIC_URL}/quotes/api/quote/${id}`;
    return axiosClient.get(url);
};